export const listGroups = [
  {
    name: "CORPORATIVO-MULTICANAL",
    id: "d8769e9c-6d9b-4b90-8a8d-e1b32211b017",
  },
  {
    name: "OPF",
    id: "5b0a521d-1b55-4569-8a3a-7a4d59807189",
  },
  {
    name: "CORPORATIVO-NAO-ELEGIVEL",
    id: "2975777c-4db6-4b15-84c8-44073f414ed8",
  },
  {
    name: "CORPORATIVO-ELEGIVEL",
    id: "9feb7c04-8c6d-4d08-9450-bd9bd19bc3cb",
  },
];

export const listGroupsEvent9d = [
  {
    name: "Corporativo",
    id: "86d29c3b-a59d-4f79-bfa9-650225761976",
  },
  {
    name: "Farma 01",
    id: "962c3517-d031-4296-aa2d-e20bb859ef86",
  },
  {
    name: "Farma 02",
    id: "4ebb509a-1662-4e4b-b2fc-84ec53599eb6",
  },
  {
    name: "Opf 01",
    id: "7837b882-d3f9-4be6-8008-d32ed40ad216",
  },
  {
    name: "Opf 02",
    id: "eade1337-9d37-4bc0-a520-6151a8765738",
  },
];
